<template>
    <div class="torrevistahermosa_torre custom__filters-apartments">
        <!-- <div class="line__vertical-mains"></div> -->
        <button-back  class="custom__filters-torres-back"/>
        <div v-if="loadFilters" class="custom__filters-torres" style="">
            
            <Availables  class="availables-desk availables-torrevistahermosa custom__filters-torres-filter" :desarrollo="desarrollo" :type="type"
                :existFilter="existFilter" :filterPrice="rangeFilterPriceTVH" :filterPriceDtos="rangeFilterPricesTVH"
                @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />
        </div>
        <Availables v-if="loadFilters" class="availables-mobile torrevistahermosa" :desarrollo="desarrollo" :type="type" :existFilter="existFilter"
            :filterPrice="rangeFilterPriceTVH" :filterPriceDtos="rangeFilterPricesTVH" @onUpdateModel="updateActiveModel" 
            @defaultDetail="hideDetail"/>
       
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torrevistahermosa torrevh-design" :class="{'show-detail':detailPiso}">
                <h1 class="caption__select">
                    <span>{{ img.name }}</span>
                    <span></span>
                </h1>
                <div class="content__depto">
                    <map-highlight-deptos :defaultActive="detailPiso" :indicators="indicators" @activeDetail="showDetailPiso" :torreLevel="levelTorre"
                    :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                <div class="content-loader detail-piso"  v-if="loading">
                    <div class="loading__box">
                        <div class="loading show">
                            <div class="spin"></div>
                        </div>
                    </div>
                </div>
                <div  v-show="detailPiso && !loading" class="detail-piso">
                    <Pisos @activeDetailPiso="showDetail" />
                </div>
                 
                <div v-show="!detailPiso && !loading"  class="detail-piso">
                    <h1 class="caption__select ">
                        <span>Seleccione un nivel, clic para ver detalles</span>
                    </h1>
                </div> 
                </div>  
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>-->
                <div class="line_horizontal" v-if="detailPiso"></div>

            </div>
            <div class="select__box torrea" v-show="detailPiso">
                <div v-show="!detail">
                    <h1 class="caption__select torrea">
                        <span>Seleccione un departamento, clic para ver detalles</span>
                    </h1>
                </div>
                <span style="display: none;">{{ detail ? 'modelo' :'' }}</span>
                
                <div v-show="detail">
                    <Buttons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../core/rediseno/MapHighlightDeptosAirea.vue";
import ButtonBack from "../../core/ButtonBack";
//import Button from "../../../core/Button.vue";
import Availables from "../../core/rediseno/Availables.vue";
import Pisos from "./Piso.vue"
import Buttons from "./Model.vue"
//import { locationsData } from "../../../utils/torrevistahermosa/data_map_pisos_torrevistahermosa"

export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        //Button,
        ButtonBack,
        Availables,
        Pisos,
        Buttons
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            //this add
            levelTorre: 50,
            //normal
            type: "departamentos",
            desarrollo: "torrevistahermosa",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            micrositeUrl: "https://dev.torrevistahermosamorelia.com/",
            torres: {
                TORREVISTAHERMOSA: {
                    name: 'TORRE VISTA HERMOSA',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrevistahermosa/torrevistahermosa_main_sky_small.png',
                    width: '630',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '508',
                    transform: '',
                    viewBox: '0 0 630 508'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            rangeFilterPriceTVH: [4465300, 13029000],
            rangeFilterPricesTVH: {
                //Se consultan con el id del dev y el id del piso: https://gn3bbxdche.execute-api.us-west-2.amazonaws.com/Production/api/locations/availability/50?towerId=286
                //'N-2': [4465300], //id=288 No existe ese id de piso
                'NIVEL 01': [8554000,6550000,8000000], //id=287
                'PB': [6250000, 8034000], //id=286
                //'NIVEL 1': [4465300], //id=289 No existe ese id de piso
                'NIVEL 2': [6150000,4800000,6968000], //id=290
                'NIVEL 3': [5453813,4465300], //id=291
                'NIVEL 4': [6250000,4509887,5786612], //id=292
                'NIVEL 5': [6320000,4554102,7160000], //id=293
                'NIVEL 6': [6380000,4598316,5900075], //id=294
                'NIVEL 7': [6450000,5722000,6450000], //id=295
                'NIVEL 8': [6013538,6013538], //id=296
                'NIVEL 9': [7466000], //id=297
                'NIVEL 10': [6630000,5742000,6420000], //id=298
                'NIVEL 11': [7562000,5775000,6183732], //id=299
                'NIVEL 12': [6750000], //id=300
                'NIVEL 13': [6800000,6073000], //id=301
                'NIVEL 14': [6870000,6130000,7784000], //id=302
                'NIVEL 15': [7863000,5480000,6940000], //id=303
                'NIVEL 16': [7689000,6254000,7920000], //id=304
                'NIVEL 17': [6524121,6311000,7050000], //id=305
                //'NIVEL 18': [], //id=306 No tiene valores
                //'NIVEL 19': [], //id=307 No tiene valores
                'NIVEL 20': [13029000], //id=308
                //'NIVEL 21': [], //id=2309 No existe ese id de piso
            },
            detailPiso:false,
            detail: false,
            indicators: [
                { id: 286, text: 'PB', transform: 'matrix(1 0 0 1 105 417)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 416, x2: 229, y2: 416, status: true, class: "" },
                { id: 287, text: 'N-1', transform: 'matrix(1 0 0 1 105 438)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 437, x2: 229, y2: 437, status: true, class: "" },
                /*{ id: 288, text: 'N-2', transform: 'matrix(1 0 0 1 105 458)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 457, x2: 229, y2: 457, status: true, class: "" },*/
                { id: 289, text: 'N1', transform: 'matrix(1 0 0 1 105 398)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 397, x2: 229, y2: 397, status: true, class: "" },
                { id: 290, text: 'N2', transform: 'matrix(1 0 0 1 105 381)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 380, x2: 229, y2: 380, status: true, class: "" },
                { id: 291 , text: 'N3', transform: 'matrix(1 0 0 1 105 365)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 364, x2: 229, y2: 364, status: true, class: "" },
                { id: 292, text: 'N4', transform: 'matrix(1 0 0 1 105 349)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 348, x2: 229, y2: 348, status: true, class: "" },
                { id: 293, text: 'N5', transform: 'matrix(1 0 0 1 105 333)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 332, x2: 229, y2: 332, status: true, class: "" },
                { id: 294, text: 'N6', transform: 'matrix(1 0 0 1 105 320)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 319, x2: 229, y2: 319, status: true, class: "" },
                { id: 295, text: 'N7', transform: 'matrix(1 0 0 1 105 304.5)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 303.5, x2: 229, y2: 303.5, status: true, class: "" },
                { id: 296, text: 'N8', transform: 'matrix(1 0 0 1 110 289)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 288, x2: 229, y2: 288, status: true, class: "" },
                { id: 297, text: 'N9', transform: 'matrix(1 0 0 1 110 273)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 272, x2: 229, y2: 272, status: true, class: "" },
                { id: 298, text: 'N10', transform: 'matrix(1 0 0 1 110 257)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 256, x2: 229, y2: 256, status: true, class: "" },
                { id: 299, text: 'N11', transform: 'matrix(1 0 0 1 110 241)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 240, x2: 229, y2: 240, status: true, class: "" },
                { id: 300, text: 'N12', transform: 'matrix(1 0 0 1 110 225)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 224, x2: 229, y2: 224, status: true, class: "" },
                { id: 301, text: 'N13', transform: 'matrix(1 0 0 1 110 209)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 208, x2: 229, y2: 208, status: true, class: "" },
                { id: 302, text: 'N14', transform: 'matrix(1 0 0 1 110 193)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 192, x2: 229, y2: 192, status: true, class: "" },
                { id: 303, text: 'N15', transform: 'matrix(1 0 0 1 110 177)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 176, x2: 229, y2: 176, status: true, class: "" },
                { id: 304, text: 'N16', transform: 'matrix(1 0 0 1 110 161)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 160, x2: 229, y2: 160, status: true, class: "" },
                { id: 305, text: 'N17', transform: 'matrix(1 0 0 1 110 145)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 144, x2: 229, y2: 144, status: true, class: "" },
                { id: 306, text: 'N18', transform: 'matrix(1 0 0 1 110 129)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 128, x2: 229, y2: 128, status: true, class: "" },
                { id: 307, text: 'N19', transform: 'matrix(1 0 0 1 110 113)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 112, x2: 229, y2: 112, status: true, class: "" },
                { id: 308, text: 'N20', transform: 'matrix(1 0 0 1 110 96)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 95, x2: 229, y2: 95, status: true, class: "" },
                /*{ id: 309, text: 'N21', transform: 'matrix(1 0 0 1 110 78)', cxB: 0, cyB: 0, rB: 0, cxW:0, cyW: 0, rW:0, x1: 140, y1: 77, x2: 229, y2: 77, status: true, class: "" },*/
            ],
            //locations:locationsData,
            //add loading
            loading:false,
            loadFilters:false
        };
    },
    computed: {
        ...mapGetters({
          filterModelos: "getStatusFilterModelos",
          locations: "getLocations",
        }),
      development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
        detailM(){
            return this.detail
        }
    },
    methods: {
      ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos", "clearDpt"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        showDetailPiso(){
            this.detail=false;
            setTimeout(() => {
               this.loading = true 
            }, 100);
            setTimeout(() => {
                this.loading =false
            }, 3000);
            setTimeout(() => {
                this.detailPiso= true;
            }, 3500);  
        },
        hideDetailPiso(){
            this.detailPiso= false;
        },
        showDetail() {
            this.detail = true;
        },
        hideDetail(){
            this.detailPiso=false
            this.detail=false;
        },
        loadingFilters(){
            setTimeout(() => {
                this.loadFilters = true
            }, 1000);
        }
    },
    async created() {
      await this.getTowerStageLevels(this.development);
      //console.log('locations:');
      //console.log(this.locations);
      //console.log('existFilter:');
      //console.log(this.existFilter);
      this.getFilterModelos(this.existFilter)
      this.loadingFilters();
    },
    async beforeDestroy() {
        await this.clearCoords();
        await this.clearDpt();
    },
    mounted() { 
        this.detail=false
    },
    watch: {
  existFilter: {
    immediate: true,
    handler() {
    //handler(val) {
      //console.log('Prop existFilter actualizada en MapHighlightDeptos:', val);
    }
  }
}
};
</script>
<style>
.st1.st2.pb-torrespp {
    font-size: 1.7rem;
}
.maphighlight__box.torrespaseop{
    overflow: hidden;
}
@media(min-width:1201px){
    .custom__filters-torres{
        display:flex; margin: 20px 20px;
    }
    .custom__filters-torres .custom__filters-torres-back{
        width:10% ;
    }
    
    .custom__filters-torres .custom__filters-torres-filter{
        width:90%;
    }
    .custom__filters-apartments .custom__filters-torres-filter{
        width: 100%;
    }
    .maphighlight__box.torrevistahermosa.torrevh-design {
        min-height: auto!important;
    }
    
    .maphighlight__box.torrevistahermosa.torrevh-design .box__svg{
        /* width: 50%!important; */
        overflow: hidden;
       /*  display: inline-block; */
    }
    .content__depto{
        display: flex;
        align-items: flex-start;
    }
    .maphighlight__box.torrevistahermosa.torrevh-design .content__depto div[type="departamentos"]{
        width: 50%!important;
         display: inline-block;
    }
    .detail-piso{
        width: 50%!important;
        display: inline-block;
    }
    .maphighlight__box.torrevistahermosa.torrevh-design{
        border: none;
        overflow: hidden;
    }
    .maphighlight__box.torrevistahermosa.torrevh-design.show-detail{
        border-right: 1px solid #000;
    }
    .maphighlight__box.torrespaseop .box__svg-deptos{
        width: 90%!important;
    }
    .maphighlight__box.torrevistahermosa.torrevh-design{
        overflow-y: scroll;
    }
}
@media(max-width:1200px){
    .maphighlight__box.torrevistahermosa.torrevh-design .content__depto div[type="departamentos"]{
        width: 70%;
        margin: auto;
    }
    
}
@media(max-width:1000px){
    .maphighlight__box.torrespaseop .box__svg-deptos{
        width: 80%!important;
    }
}

@media(max-width:600px){
    .maphighlight__box.torrevistahermosa.torrevh-design .content__depto div[type="departamentos"]{
        width: 90%;
        margin: auto;
    }
    
}
</style>
